module.exports = __webpack_public_path__ + "img/DK69556728.c38c2116.png";